import styled, { css, keyframes } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import { PRESETS } from './TemplateCard.presets';

const appearFromTop = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }
  80% {
    opacity: 1;
    transform: translateY(0);
  }
  90% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(0);
  }
`;

export const StyledTemplateCard = styled.div<{
  imageDimensions: null | { width: number; height: number };
  height?: number;
  width?: number;
  isMultipage: boolean;
}>`
  ${({ theme, imageDimensions, height, width, isMultipage }) => {
    return css`
      display: flex;
      flex-direction: column;
      position: relative;
      ${height &&
      `
        max-height: ${utils.rem(height)};
      `};
      ${width &&
      `
        max-width: ${utils.rem(width)};
      `};
      ${isMultipage &&
      `
        height: 100%;
      `};
      &:hover .header-right-actions {
        opacity: 1;
        animation: ${appearFromTop} 0.5s ease forwards;
      }
    `;
  }}
`;

export const StyledViewer = styled.div<{ isMultipage: boolean }>`
  ${({ theme, isMultipage }) => `
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      ${
        isMultipage &&
        `
        height: calc(100% - ${utils.rem(theme.Spacing.Size.MediumLarge)});
      `
      }
  `}
`;

export const StyledCardImageWrapper = styled.img`
  ${({ theme }) => {
    return `
      height: auto;
      width: 100%;
      border-radius: ${utils.rem(theme.Border.Radius.Medium)};
      cursor: pointer;
  `;
  }}
`;

export const StyledMultipageViewer = styled.div<{
  imageDimensions: null | { width: number; height: number };
}>`
  ${({ theme, imageDimensions }) => `
    position: relative;
    overflow: hidden;
    border-radius: ${utils.rem(theme.Spacing.Size.XSmall)};
    height: 100%;

    & .swiper {
      width: 100%;
      height: 100%;
    }

    & .swiper-slide {
      display: flex;
      align-items: center;
      justify-content: center;

      // & img {
      //   width: auto;
      //   height: 100%;
      // }
    }
  `}
`;

export const StyledCardSwiperImageWrapper = styled.img<{
  isPortrait?: boolean;
}>`
  ${({ theme, isPortrait }) => {
    return `
      height: ${isPortrait ? '100%' : 'auto'};
      width: ${isPortrait ? 'auto' : '100%'};
      object-fit: contain;
      object-position: center;
      border-radius: ${utils.rem(theme.Border.Radius.Medium)};
      cursor: pointer;
  `;
  }}
`;

export const StyledCardContent = styled.div`
  ${({ theme }) => {
    return css`
      display: flex;
      height: 100%;
      flex-direction: column;
      position: relative;
      border: ${utils.rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border};
      border-radius: ${utils.rem(theme.Border.Radius.XLarge)};

      &:hover .header-right-actions {
        opacity: 1;
        animation: ${appearFromTop} 0.5s ease forwards;
      }

      @media (min-width: ${theme.Screen.Size.Small}px) {
        border: none;
      }
    `;
  }}
`;

export const StyledCardVideoWrapper = styled.video`
  ${({ theme }) => `
    height: auto;
    width: calc(100% - ${utils.rem(theme.Spacing.Size.XXXLarge)});
    max-width: 100%;
    max-height: 100%;
    border-radius: ${utils.rem(theme.Border.Radius.Large)};

    @media (min-width: ${theme.Screen.Size.Small}px) {
      width: 100%;
    };
  `}
`;

export const StyledCardSkeleton = styled.div`
  ${({ theme }) => `
    width: ${utils.rem(PRESETS.default.width)};
    height: ${utils.rem(PRESETS.default.height)};
      & .ant-skeleton-image {
        width: ${utils.rem(PRESETS.default.width)} !important;
        height: ${utils.rem(PRESETS.default.height)} !important;
        border-radius: ${utils.rem(theme.Border.Radius.Large)};

      };
    margin-right: ${utils.rem(theme.Spacing.Size.MediumSmall)};
  `};
`;

export const StyledCardSwiperVideoWrapper = styled.video`
  ${({ theme }) => `
    height: auto;
    width: calc(100% - ${utils.rem(theme.Spacing.Size.XXXLarge)});
    max-width: 100%;
    max-height: 100%;
    border-radius: ${utils.rem(theme.Border.Radius.Large)};

    @media (min-width: ${theme.Screen.Size.Small}px) {
      width: 100%;
    };
  `}
`;
